export const navItemConstants = (showDebugTools: boolean) => [
  {
    icon: 'dashboard',
    label: 'Dashboard',
    route: '/dashboard',
    enabled: true,
  },
  {
    icon: 'add',
    label: 'Create Key',
    route: '/create-key',
    enabled: true,
  },
  { icon: 'list', label: 'List Keys', route: '/list-keys', enabled: false },
  { icon: 'info', label: 'Key Info', route: '/key-info', enabled: false },
  {
    icon: 'edit_note',
    label: 'Change Key Expiration',
    route: '/change-expiration',
    enabled: false,
  },
  {
    icon: 'find_in_page',
    label: 'Introspect Key',
    route: '/introspect-key',
    enabled: true,
  },
  {
    icon: 'science',
    label: 'API Tester',
    route: '/api-tester',
    enabled: showDebugTools,
  },
  {
    icon: 'search',
    label: 'Inspect Tokens',
    route: '/oidc-tokens',
    enabled: showDebugTools,
  },
];
